import { media, spacing } from '@gyym/ui'
import styled from 'styled-components'

export const CoverContainer = styled.div`
  height: 230px;
  display: block;
  position: relative;
  margin: ${spacing(0, -4)};

  ${media.tablet} {
    height: 340px;
  }

  ${media.pc} {
    margin: ${spacing(0, -10)};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 10;
    // Dotted image overlay
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAYAAABWKLW/AAAAAXNSR0IArs4c6QAAABtJREFUGFdjZGBI9mVgmLuZgYGBgRFEwAAKBwBCNQIEt9nIVwAAAABJRU5ErkJggg==)
      repeat;
  }
`
